import React, { ReactNode } from 'react';
import { Button, Modal as RsModal, ModalProps, ButtonProps, Loader, Icon } from 'rsuite';

interface CusModalProps extends ModalProps {
  onCancel?: ButtonProps['onClick'];
  closeButton?: boolean;
  onConfirm?: ButtonProps['onClick'];
  footer?: ReactNode;
  header?: ReactNode;
  onClose?: ModalProps['onHide'];
  confirmLoading?: boolean;
  bodyLoading?: boolean;
  appearance?: 'default' | 'warning';
  confirmDisabled?: boolean;
}

const Modal = React.memo(function CusModal({
  children,
  show = false,
  size = 'sm',
  closeButton = false,
  onClose,
  onCancel,
  onConfirm,
  bodyLoading = false,
  confirmLoading = false,
  confirmDisabled = false,
  footer,
  header,
  appearance = 'default',
  ...props
}: CusModalProps) {
  return (
    <RsModal show={show} size={size} {...props}>
      <RsModal.Header closeButton={closeButton} onHide={onClose}>
        {appearance !== 'warning' && header}
      </RsModal.Header>
      <RsModal.Body
        {...(appearance === 'warning' && { classPrefix: 'cus-modal-body-warning-mode' })}
      >
        {bodyLoading ? (
          <Loader center />
        ) : (
          <>
            {appearance === 'warning' && (
              <Icon
                icon="remind"
                style={{
                  color: '#ffb300',
                  fontSize: 24,
                  marginRight: 5,
                }}
              />
            )}
            {children}
          </>
        )}
      </RsModal.Body>
      <RsModal.Footer>
        {footer || (
          <>
            <Button
              appearance="primary"
              loading={confirmLoading}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              确认
            </Button>
            <Button appearance="subtle" onClick={onCancel}>
              取消
            </Button>
          </>
        )}
      </RsModal.Footer>
    </RsModal>
  );
});
export default Modal;
